const Grid = () => {
  return (
    <svg
      width="6000"
      height="1123"
      viewBox="0 0 6000 1123"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <pattern
          id="smallGrid"
          width={40}
          height={40}
          patternUnits="userSpaceOnUse"
        >
          <g
            stroke={'var(--grid-color, var(--brand-color-grey-9))'}
            strokeWidth={2}
            strokeDasharray="2 2"
          >
            <line x1={0} y1={0} x2={0} y2={40} />
            <line x1={0} y1={0} x2={40} y2={0} />
          </g>
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#smallGrid)" />
    </svg>
  );
};

export default Grid;
